<script>
    import { api_host, user_store, user_info_store } from "../../stores.js";
    import { init_data, get_user_info } from '../../init.js';
    import { querystring, push, pop } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import IFTAInput from "../../utils/iftainput.svelte";
    import GoogleMap from "../../utils/GoogleMap.svelte";
    import CreditCardEntry from "../../utils/creditcardentry.svelte";
    import { state_codes } from '../../globals.js';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { formatDate, getFormatDateByOffset, check_access_able, get_possible_roles, handle_not_subscribed } from '../../utils/format.js';
    import Swal from "sweetalert2";


    let profile = {};
    let is_busy = false;
    let is_password_keep = true;
    let content_title = "Edit / Review User";
    let uid = 0;
    let myself = {};
    let refresh = false;

    let adding_email = false, temp_email = '';
    let emails = [];

    const add_email = () => {
        temp_email = temp_email.trim();
        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!temp_email) 
            toast_message(false, 'Please enter email', 2000);
        else if (!temp_email.match(mailformat)) {
            toast_message(false, 'Please type valid email', 2000);
        } else {
            emails = [
                ...emails,
                temp_email
            ];
            temp_email = '';
            adding_email = false;
        }
    };

    const remove_email = async (index) => {
        const result = await Swal.fire({
            title: "Are you sure you want to delete this email?",
            text: '',
            buttonsStyling: true,
            confirmButtonClass: "button",
            confirmButtonText: 'Ok',
            cancelButtonText: "Cancel",
            showCancelButton: true,
            icon: "warning"
        });
        if (!result.isConfirmed) return;

        emails.splice(index, 1);
        emails = emails;
    };


    const { auth_type, auth_token, domain_code } = getToken();

    user_store.subscribe((value) => {
        myself = value;
    });

    let show_cc_entry = false, editing_cc_index = -1;
    let cc_number, cc_name, cc_cvc, cc_expiry;
    let is_cc_number_valid, is_cc_cvc_valid, is_cc_expiry_valid;
    let new_card_false = false;
    let add_cc_entry = false;
    let new_cc_number, new_cc_name, new_cc_cvc, new_cc_expiry;
    let is_new_cc_number_valid, is_new_cc_cvc_valid, is_new_cc_expiry_valid;

    const refresh_user_info = async (_refresh=false) => {
        refresh = _refresh;
        const params = new URLSearchParams($querystring);
        if (params.has("uid")) {
            uid = parseInt(params.get("uid"));
            get_user_info(uid);
        }
    }
    onMount(async () => {
        await refresh_user_info();
    });

    let services_table_header_config = [
        {'t': 'Date/Time', 'fm': 'd', 'a': true},
        {'t': 'Client', 'fm': 'cn', 'a': false},
        {'t': 'Address', 'fm': 'ad', 'a': false},
        {'t': 'Crew', 'fm': 'cr', 'a': false},
        {'t': 'Service Type', 'fm': 'st', 'a': true},
        {'t': 'Price', 'fm': 'p', 'a': true},
        {'t': 'Crew Price', 'fm': 'ud', 'a': true},
        {'t': 'Profit', 'fm': 'pt', 'a': true}
    ];
    let services_table_header_config_origin = services_table_header_config;

    let fields = [
        {
            "index": 0,
            "group": "basic1",
            "type": "text",
            "label": "First Name",
            "value": "",
            "placeholder": "eg. Bart",
            "name": "user[first_name]",
            "error_text": "First Name is required",
            "validation_function": () => {
                if (fields[0].value.length) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    return false;
                }
            }
        }, {
            "index": 1,
            "group": "basic1",
            "type": "text",
            "label": "Last Name",
            "value": "",
            "placeholder": "eg. Simpson",
            "name": "user[last_name]",
            "validation_function": () => {
                if (fields[3].value === 'Vendor') { fields[1]['show_error'] = false; return true; }
                if (fields[1].value.length) {
                    fields[1]['show_error'] = false;
                    return true;
                } else {
                    fields[1]['show_error'] = true;
                    fields[1]['error_text'] = 'Last Name is required';
                    return false;
                }
            }
        }, {
            "index": 2,
            "group": "basic2",
            "type": "text",
            "label": "Email",
            "value": "",
            "placeholder": "eg. bsimpson@mailinator.com",
            "name": "user[email]",
            "validation_function": () => {
                if (fields[3].value === 'Vendor' && fields[2].value.length === 0) {
                    fields[2]['show_error'] = false;
                    return true;
                }
                const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (fields[2].value.match(mailformat)) {
                    fields[2]['show_error'] = false;
                    return true;
                } else {
                    fields[2]['show_error'] = true;
                    fields[2]['error_text'] = 'Invalid email';
                    return false;
                }
            }
        }, {
            "index": 3,
            "group": "basic2",
            "type": "select",
            "label": "Type of User",
            "value": "Contractor",
            "select_options": get_possible_roles(myself.role, myself.plan_type),
            "name": "user[role]",
            "change_function": (evt) => {
                if (evt.target.value === 'Manager' || evt.target.value === 'Admin' || evt.target.value === 'Applicant') {
                    fields[11].hidden = true;
                } else {
                    if (evt.target.value === 'Vendor') {
                        fields[0].label = "Name";
                        fields[0].error_text = "Name is required";
                        fields[1].hidden = true;
                        fields[27].hidden = true;
                    } else {
                        fields[0].label = "First Name";
                        fields[0].error_text = "First Name is required";
                        fields[1].hidden = false;
                        fields[27].hidden = false;
                    }
                    fields[11].hidden = true;
                }
                if (evt.target.value === 'Employee' || evt.target.value === 'Contractor') {
                    fields[28].hidden = false;
                } else {
                    fields[28].hidden = true;
                }
                if (evt.target.value === 'Client') {
                    fields[29].hidden = false;
                    fields[30].hidden = false;
                    fields[31].hidden = false;
                } else {
                    fields[29].hidden = true;
                    fields[30].hidden = true;
                    fields[31].hidden = true;
                }
            },
            "validation_function": () => { return true; }
        }, {
            "index": 4,
            "group": "contractor",
            "type": "select",
            "label": "Business Structure",
            "value": "N/A",
            "select_options": ["N/A", "Sole Proprietorship", "LLC", "Other"],
            "name": "user[business_structure]",
            "validation_function": () => { return true; }
        }, {
            "index": 5,
            "group": "address",
            "type": "text",
            "label": "Street",
            "value": "",
            "placeholder": "eg. 123 My street",
            "validation_function": () => {
                if (fields[3].value === 'Vendor') { fields[5]['show_error'] = false; return true; }
                if (fields[5].value.length) {
                    fields[5]['show_error'] = false;
                    return true;
                } else {
                    fields[5]['show_error'] = true;
                    fields[5]['error_text'] = 'Street is required';
                    return false;
                }
            }
        }, {
            "index": 6,
            "group": "address",
            "type": "text",
            "label": "City",
            "value": "",
            "placeholder": "eg. Springfield",
            "name": "user[city]",
            "validation_function": () => {
                if (fields[3].value === 'Vendor') { fields[6]['show_error'] = false; return true; }
                if (fields[6].value.length) {
                    fields[6]['show_error'] = false;
                    return true;
                } else {
                    fields[6]['show_error'] = true;
                    fields[6]['error_text'] = 'City is required';
                    return false;
                }
            }
        }, {
            "index": 7,
            "group": "address",
            "type": "select",
            "label": "State",
            "value": "Arizona",
            "select_options": Object.keys(state_codes),
            "name": "user[state]",
            "change_function": (evt) => {
                if (evt.target.value.length) {
                    fields[7]['show_error'] = false;
                } else {
                    fields[7]['show_error'] = true;
                    fields[7]['error_text'] = 'Invalid State';
                }
            },
            "validation_function": () => {
                if (fields[3].value === 'Vendor') { fields[7]['show_error'] = false; return true; }
                if (fields[7].value.length) {
                    fields[7]['show_error'] = false;
                    return true;
                } else {
                    fields[7]['show_error'] = true;
                    fields[7]['error_text'] = 'Invalid State';
                    return false;
                }
            }
        }, {
            "index": 8,
            "group": "address",
            "type": "text",
            "label": "Zip Code",
            "value": "",
            "placeholder": "Optional (eg. 90210)",
            "name": "user[zipcode]",
            "validation_function": () => {
                const zipformat = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                if (fields[8].value.length == 0) return true;
                if (fields[8].value.match(zipformat)) {
                    fields[8]['show_error'] = false;
                    return true;
                } else {
                    fields[8]['show_error'] = true;
                    fields[8]['error_text'] = 'Invalid zipcode';
                    return false;
                }
            }
        }, {
            "index": 9,
            "group": "contact",
            "type": "text",
            "label": "Home Phone",
            "value": "",
            "placeholder": "eg. 000-000-0000",
            "name": "user[home_phone]",
            'change_function': (evt) => {
                var x = evt.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                evt.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            "validation_function": () => {
                if (fields[3].value === 'Vendor' && fields[9].value.length === 0) {
                    fields[9]['show_error'] = false;
                    return true;
                }
                const phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (fields[9].value.match(phoneformat)) {
                    fields[9]['show_error'] = false;
                    return true;
                } else {
                    fields[9]['show_error'] = true;
                    fields[9]['error_text'] = 'Invalid phone number';
                    return false;
                }
            }
        }, {
            "index": 10,
            "group": "contact",
            "type": "text",
            "label": "Cell Phone",
            "value": "",
            "placeholder": "eg. 000-000-0000",
            "name": "user[mobile_phone]",
            'change_function': (evt) => {
                var x = evt.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                evt.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            "validation_function": () => {
                if (fields[3].value === 'Vendor' && fields[10].value.length === 0) {
                    fields[10]['show_error'] = false;
                    return true;
                }
                const phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (fields[10].value.match(phoneformat)) {
                    fields[10]['show_error'] = false;
                    return true;
                } else {
                    fields[10]['show_error'] = true;
                    fields[10]['error_text'] = 'Invalid phone number';
                    return false;
                }
            }
        }, {
            "index": 11,
            "group": "contact",
            "type": "select",
            "label": "Carrier",
            "value": "Other",
            "hidden": true,
            "select_options": ["Verizon", "ATT", "T-Mobile", "Sprint", "Cricket", "MetroPCS", "MintMobile", "BoostMobile", "Other"],
            "name": "user[carrier]",
            "validation_function": () => { return true; },
        }, {
            "index": 12,
            "group": "password",
            "type": "password",
            "label": "New Password",
            "value": "",
            "name": "user[password]",
            "validation_function": (evt) => {
                const _is_password_keep = evt ? evt.target.checked : is_password_keep;
                if (!_is_password_keep && isPasswordRequire(profile.role)) {
                    const lowerCaseLetters = /[a-z]/g;
                    const upperCaseLetters = /[A-Z]/g;
                    const numbers = /[0-9]/g;
                    if (fields[12].value.length >= 6 && fields[12].value.match(lowerCaseLetters) && fields[12].value.match(upperCaseLetters) && fields[12].value.match(numbers)) {
                        fields[12]['show_error'] = false;
                        return true;
                    } else {
                        fields[12]['show_error'] = true;
                        fields[12]['error_text'] = 'Password is weak';
                        return false;
                    }
                } else {
                    fields[12]['show_error'] = false;
                    return true;
                }
            }
        }, {
            "index": 13,
            "group": "password",
            "type": "password",
            "label": "New Password Confirmation",
            "value": "",
            "name": "user[password]",
            "validation_function": (evt) => {
                const _is_password_keep = evt ? evt.target.checked : is_password_keep;
                if (!_is_password_keep) {
                    if (fields[13].value.length) {
                        fields[13]['show_error'] = false;
                        return true;
                    } else {
                        fields[13]['show_error'] = true;
                        fields[13]['error_text'] = 'Confirm Password is required';
                        return false;
                    }
                } else {
                    fields[13]['show_error'] = false;
                    return true;
                }
            }
        }, {
            "index": 14,
            "group": "contractor",
            "type": "toggle",
            "label": "Has Experience?",
            "value": true,
            "name": "user[has_experience]",
            "validation_function": () => { return true; }
        }, {
            "index": 15,
            "group": "contractor",
            "type": "text",
            "label": "Years of Experience",
            "value": "",
            "placeholder": "eg: 2",
            "name": "user[years_experience]",
            "validation_function": () => {
                if (parseInt(fields[15].value) >= 0) {
                    fields[15]['show_error'] = false;
                    return true;
                } else {
                    fields[15]['show_error'] = true;
                    fields[15]['error_text'] = 'Year of Experience is required';
                    return false;
                }
            }
        }, {
            "index": 16,
            "group": "contractor",
            "type": "select",
            "label": "Time Availability",
            "value": "Part-Time",
            "select_options": ["Full-Time", "Part-Time"],
            "name": "user[time_availability]",
            "validation_function": () => { return true; }
        }, {
            "index": 17,
            "group": "contractor",
            "type": "toggle",
            "label": "Authorized to Work?",
            "value": true,
            "name": "user[authorized]",
            "validation_function": () => { return true; }
        }, {
            "index": 18,
            "group": "contractor",
            "type": "toggle",
            "label": "Insured?",
            "value": false,
            "name": "user[insured]",
            "validation_function": () => { return true; }
        }, {
            "index": 19,
            "group": "contractor",
            "type": "toggle",
            "label": "English Fluency?",
            "value": true,
            "name": "user[english_fluency]",
            "validation_function": () => { return true; }
        }, {
            "index": 20,
            "group": "contractor",
            "type": "toggle",
            "label": "Has a Truck?",
            "value": false,
            "name": "user[has_truck]",
            "validation_function": () => { return true; }
        }, {
            "index": 21,
            "group": "contractor",
            "type": "toggle",
            "label": "Internet Access?",
            "value": true,
            "name": "user[internet_access]",
            "validation_function": () => { return true; }
        }, {
            "index": 22,
            "group": "contractor",
            "type": "toggle",
            "label": "Smart Phone?",
            "value": true,
            "name": "user[smart_phone]",
            "validation_function": () => { return true; }
        }, {
            "index": 23,
            "group": "contractor2",
            "type": "textarea",
            "label": "Lawn Care Equipment",
            "name": "user[lawn_care_equipment]",
            "hidden": true,
            "validation_function": () => { return true; }
        }, {
            "index": 24,
            "group": "contractor2",
            "type": "textarea",
            "label": "How did you hear about us?",
            "name": "user[hear_about_us]",
            "hidden": true,
            "validation_function": () => { return true; }
        }, {
            "index": 25,
            "group": "comments",
            "type": "textarea",
            "label": "Additional Comments",
            "name": "user[additional_comments]",
            "validation_function": () => { return true; }
        }, {
            "index": 26,
            "group": "comments",
            "type": "textarea",
            "label": "Internal Comments",
            "name": "user[internal_comments]",
            "hidden": myself.role !== 'landscaper',
            "validation_function": () => { return true; }
        }, {
            "index": 27,
            "group": "basic2",
            "type": "toggle",
            "label": "Status",
            "value": true,
            "name": "user[is_active]",
            "select_options": ['Active', 'Inactive'],
            "validation_function": () => { return true; }
        }, {
            "index": 28,
            "group": "basic1",
            "type": "text",
            "label": "Job Title",
            "value": "",
            "placeholder": "",
            "name": "user[job_title]",
            "maxlength": 100,
            "hidden": true,
            "validation_function": () => { return true; }
        },
        {
            "index": 29,
            "group": "basic1",
            "type": "text",
            "label": "Business Name",
            "value": "",
            "placeholder": "",
            "name": "user[business_name]",
            "maxlength": 100,
            "hidden": true,
            "validation_function": () => { return true; }
        },
        {
            "index": 30,
            "group": "basic1",
            "type": "text",
            "label": "Title",
            "value": "",
            "placeholder": "",
            "name": "user[title]",
            "maxlength": 100,
            "hidden": true,
            "validation_function": () => { return true; }
        },
        {
            "index": 31,
            "group": "basic2",
            "type": "toggle",
            "label": "Send Reminder",
            "value": false,
            "hidden": true,
            "name": "user[send_reminder]",
            "validation_function": () => { return true; }
        }
    ];

    const comparePassword = (password) => {
        const lowerCaseLetters = /[a-z]/g;
        const upperCaseLetters = /[A-Z]/g;
        const numbers = /[0-9]/g;
        if (fields[12].value.length >= 6 && fields[12].value.match(lowerCaseLetters) && fields[12].value.match(upperCaseLetters) && fields[12].value.match(numbers)) {
            fields[12]['show_error'] = false;
        } else {
            fields[12]['show_error'] = true;
            fields[12]['error_text'] = 'Password is weak';
            return;
        }
        const is_matching = fields[12].value === password && fields[13].value === password;
        if (!is_matching) {
            fields[12]['show_error'] = true;
            fields[12]['error_text'] = 'Password is not matching';
            fields[13]['show_error'] = true;
            fields[13]['error_text'] = 'Password is not matching';
        } else {
            fields[12]['show_error'] = false;
            fields[13]['show_error'] = false;
        }
        return is_matching;
    }

    const isPasswordRequire = (role) => {
        if (role !== undefined) {
            const _role = role.toLowerCase();
            if (myself.plan_type === 'prime' || myself.plan_type === 'free') {
                if (_role !== 'applicant' && _role !== 'vendor') return true;
            } else {
                if (_role !== 'applicant' && _role !== 'vendor' && _role !== 'contractor' && _role !== 'employee' && _role !== 'client' && _role !== 'lead') return true;
            }
        }
        return false;
    }

    const validateCC = () => {
        let is_valid = true;
        if (show_cc_entry) {
            if (cc_number.includes('*') || cc_cvc.includes('*')) {
                is_cc_number_valid = false;
                is_cc_cvc_valid = false;
            }
            is_valid = is_cc_number_valid && is_cc_expiry_valid && is_cc_cvc_valid;
        }
        return is_valid;
    }
    const validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (!field.validation_function()) { is_valid = false; }
        });
        if (fields[12].value !== fields[13].value) { is_valid = false; }

        if (!validateCC()) {
            is_valid = false;
        }

        return is_valid;
    }

    const update_user = async () => {
        if (!myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }
        is_busy = true;
        if (validateForm()) {
            let email = fields[2].value;
            if (fields[3].value === 'Vendor' && email.length === 0) {
                email = `${Date.now()}${myself.id}@houseofyards.tmp`;
            }
            const payload = {
                uid,
                first_name: fields[0].value,
                last_name: fields[1].value,
                business_name: fields[29].value,
                title: fields[30].value,
                job_title: fields[28].value,
                email: email.toLowerCase(),
                role: fields[3].value.toLowerCase(),
                business_structure: fields[4].value,
                street: fields[5].value,
                city: fields[6].value,
                state: fields[7].value,
                zipcode: fields[8].value,
                home_phone: fields[9].value,
                mobile_phone: fields[10].value,
                carrier: fields[11].value,
                password: is_password_keep ? '' : fields[12].value,
                has_experience: fields[14].value,
                years_experience: fields[15].value,
                time_availability: fields[16].value,
                authorized: fields[17].value,
                insured: fields[18].value,
                english_fluency: fields[19].value,
                has_truck: fields[20].value,
                internet_access: fields[21].value,
                smart_phone: fields[22].value,
                lawn_equipment: fields[23].value,
                hear_about_us: fields[24].value,
                additional_comments: fields[25].value,
                internal_comments: fields[26].value,
                is_active: fields[27].value,
                today_date: formatDate(getFormatDateByOffset(0)),
                is_paycard_update: show_cc_entry,
                cc_name,
                cc_number,
                cc_expiry,
                cc_cvc,
                emails: fields[3].value.toLowerCase() === 'client' ? emails : [],
                send_reminder: fields[31].value
            };
            const res = await doFetch(
                api_host + "/api/update/user",
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                toast_message(true, res.msg, 2000);
                init_data('users');
                init_data('jobs');
                if (myself.role === profile.role) {
                    init_data('myself');
                }
                push(`#/User_Review?uid=${uid}`);
            }
            else { toast_message(false, res.msg || 'Bad request', 2000); }
        } else {
            toast_message(false, 'Missing or invalid info', 2000);
        }
        is_busy = false;
    }

    user_info_store.subscribe(value => {
        if (value.profile && value.services) {
            profile = value.profile;
            if (profile.cc_number) {
                cc_name = profile.cc_name;
                cc_number = profile.cc_number;
                cc_expiry = profile.cc_expiry;
                cc_cvc = profile.cc_cvc;
                is_cc_number_valid = true;
                is_cc_expiry_valid = true;
                is_cc_cvc_valid = true;
            }
            if (!check_access_able(myself.role, profile.role)) { push('#/Users?filter=all'); }
            if (!refresh) {
                services_table_header_config = [...services_table_header_config_origin];
                if (profile.role === 'contractor' || profile.role === 'employee') {
                    services_table_header_config[1].a = true;
                    services_table_header_config.splice(3, 1);
                    if (profile.role === 'employee') {
                        services_table_header_config.splice(5, 2);
                    }
                } else {
                    services_table_header_config[3].a = true;
                    services_table_header_config.splice(1, 1);
                }
            }
            if (profile.state.length === 2) {
                profile.state = Object.keys(state_codes).find(code => state_codes[code] == profile.state);
            }
            fields[0].value = profile.first_name;
            fields[1].value = profile.last_name;
            fields[2].value = profile.email.includes('houseofyards.tmp') ? '' : profile.email;
            if (profile.role === 'landscaper') {
                fields[3].hidden = true;
                fields[27].hidden = true;
            }
            if (profile.role === 'vendor') {
                fields[0].label = "Name";
                fields[0].error_text = "Name is required";
                fields[1].hidden = true;
                fields[27].hidden = true;
            }
            fields[3].value = profile.role.charAt(0).toUpperCase() + profile.role.slice(1).toLowerCase();
            if (profile.role === 'admin' || profile.role === 'landscaper' || profile.role === 'manager') {
                fields[11].hidden = true;
            }
            if (profile.role === 'client') {
                fields[29].hidden = false;
                fields[30].hidden = false;
                fields[31].hidden = false;
            } else {
                fields[29].hidden = true;
                fields[30].hidden = true;
                fields[31].hidden = true;
            }
            fields[4].value = profile.business_structure;
            fields[5].value = profile.address;
            fields[6].value = profile.city;
            fields[7].value = profile.state.length == 2 ? Object.keys(state_codes).find(item => state_codes[item] == profile.state) : profile.state;
            fields[8].value = profile.zipcode;
            fields[9].value = profile.home_phone;
            fields[10].value = profile.mobile_phone;
            fields[11].value = profile.carrier;
            fields[12].value = profile.temporary_password;
            fields[13].value = profile.temporary_password;
            fields[14].value = profile.has_experience;
            fields[15].value = profile.years_experience;
            fields[16].value = profile.time_availability;
            fields[17].value = profile.authorized;
            fields[18].value = profile.insured;
            fields[19].value = profile.english_fluency;
            fields[20].value = profile.has_truck;
            fields[21].value = profile.internet_access;
            fields[22].value = profile.smart_phone;
            fields[23].value = profile.lawn_equipment;
            if (profile.role === 'contractor' || profile.role === 'employee') {
                fields[24].hidden = false;
                fields[28].hidden = false;
            }
            fields[24].value = profile.hear_about_us;
            fields[25].value = profile.additional_comments;
            fields[26].value = profile.internal_comments;
            fields[27].value = profile.is_active;
            if (profile.role === 'applicant') fields[27].hidden = true;
            fields[29].value = profile.business_name;
            fields[30].value = profile.title;
            fields[31].value = profile.send_reminder;
            emails = profile.emails ?? [];
        }
    });
</script>

<Header title={content_title} is_busy={is_busy} />

<div class="contentholder">
    <div class="section basic">
        <div class="sectionsubtitle">Basic</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff formrow pricingsettings">
                {#each fields.filter((e) => e.group === "basic1") as nf}
                    {#if (myself.role === 'landscaper' || myself.role === 'admin') ? true : nf.label !== 'Active'}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                        readonly={nf.readonly}
                        disabled={nf.disabled}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:hidden={nf.hidden}
                        bind:value={nf.value}
                        bind:change_function={nf.change_function}
                        bind:validation_function={nf.validation_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                    {/if}
                {/each}
            </div>
            <div class="ff formrow pricingsettings">
                {#each fields.filter((e) => e.group === "basic2") as nf}
                    {#if (myself.role === 'landscaper' || myself.role === 'admin') ? true : nf.label !== 'Active'}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                        readonly={nf.readonly}
                        disabled={nf.disabled}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:hidden={nf.hidden}
                        bind:value={nf.value}
                        bind:change_function={nf.change_function}
                        bind:validation_function={nf.validation_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                    {/if}
                {/each}
            </div>
        </div>

        {#if (fields[3].value.toLowerCase() == 'client')}
        <div class="sectioninfo pricingsettings">
            <div class="ff" style="padding: 5px; padding-bottom: 30px;">
                <div style="font-weight: 600; padding-bottom: 10px;">Secondary Emails</div>
                <div style="display: flex; flex-direction: column; width: 300px;">
                    {#each emails as email, index }
                    <div style="display: flex; flex-direction: row; justify-content: space-between; padding-bottom: 5px;">
                        <span>{email}</span>
                        <button class="btn-icon" on:click={() => remove_email(index)}><i class="fa fa-trash"></i></button>
                    </div>
                    {/each}
                </div>
                {#if adding_email}
                <div style="display: flex;">
                    <input
                        type="email"
                        bind:value={temp_email}
                        on:keyup={event => {
                            if (event.key === 'Enter') {
                                add_email();
                            }
                        }}
                    />
                    <button style="margin-left: 10px;" class="save" on:click={add_email}>Add</button>
                    <button style="margin-left: 10px;" on:click={() => adding_email=false}>Cancel</button>
                </div>
                {:else}
                <div>
                    <button class="save" on:click={() => adding_email=true}><i class="fa-plus" style="font-style: normal;"></i> Add</button>
                </div>
                {/if}
            </div>
        </div>
        {/if}


    </div>

    <div class="contactdetails">
        <div class="section" style='margin-bottom: 20px;'>
            <div class="sectionsubtitle">Address</div>
            <div class="sectioninfo pricingsettings">
                <div class="ff rowwrap pricingsettings">
                    {#each fields.filter((e)=>e.group === "address") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                        readonly={nf.readonly}
                        disabled={nf.disabled}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:value={nf.value}
                        bind:change_function={nf.change_function}
                        bind:validation_function={nf.validation_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                    {/each}
                </div>    
            </div>
        </div>
        <div class="section">
            <div class="sectionsubtitle">Contact</div>
            <div class="sectioninfo pricingsettings">
                <div class="ff rowwrap pricingsettings">
                    {#each fields.filter((e)=>e.group === "contact") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                        readonly={nf.readonly}
                        disabled={nf.disabled}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:value={nf.value}
                        bind:hidden={nf.hidden}
                        bind:change_function={nf.change_function}
                        bind:validation_function={nf.validation_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                    {/each}
                </div>    
            </div>
        </div>
    </div>

    <!-- <div class="section map">
        <div class="sectionsubtitle">Map</div>
        <div class="mapholder">
            <GoogleMap
                address={profile.address}
                city={profile.city}
                state={profile.state}
            /> 
        </div>
    </div> -->

    {#if myself.plan_type !== 'basic' && fields[3].value.toLowerCase() === 'client'}
    <div class="section billininginfo">
        <div class="sectionsubtitle">Billing Information</div>
        {#if !show_cc_entry}
        <div class="billininginfotableholder">
            <table style="width: 100%;max-width: 750px;">
                <tr>
                    <th>Type</th>
                    <th>Number</th>
                    <th>Expiry</th>
                    <th></th>
                    <th>Action</th>
                </tr>
                {#each profile.paycards as paycard, cc_index}
                <tr>
                    <td style='text-transform: capitalize;'>{paycard.cc_brand}</td>
                    <td>{paycard.cc_number}</td>
                    <td>{paycard.cc_expiry}</td>
                    <td>
                        <div
                            class={`${paycard.is_default ? 'cc_default' : 'cc_set_default_btn'}`}
                            on:click={async () => {
                                if (!paycard.is_default) {
                                    const res = await doFetch(
                                        `${api_host}/api/paycard/set/default`,
                                        'POST',
                                        { 'hid': uid, 'paycard_id': paycard.cc_id },
                                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                                    );
                                    if (res.status) {
                                        refresh_user_info();
                                        toast_message(true, res.msg, 2000);
                                    } else {
                                        toast_message(false, res.msg || 'Failed set default card', 2000);
                                    }
                                }
                            }}
                        >
                            {paycard.is_default ? 'default' : 'set as default'}
                        </div>
                    </td>
                    <td>
                        <button class='cc_edit_btn' on:click={() => {
                            show_cc_entry = true;
                            editing_cc_index = cc_index;
                            cc_name = profile.paycards[editing_cc_index].cc_name;
                            cc_number = profile.paycards[editing_cc_index].cc_number;
                            cc_expiry = profile.paycards[editing_cc_index].cc_expiry;
                            cc_cvc = profile.paycards[editing_cc_index].cc_cvc;
                        }}>Edit</button>
                        {#if profile.paycards.length > 1}
                        <button class='cc_edit_btn cc_delete_button' on:click={async () => {
                            Swal.fire({
                                title: 'Delete Card?',
                                buttonsStyling: true,
                                confirmButtonClass: "button",
                                confirmButtonText: 'OK',
                                cancelButtonText: "Cancel",
                                showCancelButton: true,
                                icon: "warning"
                            }).then(async (e) => {
                                if (e.isConfirmed) {
                                    console.log('running');
                                    const res = await doFetch(
                                        `${api_host}/api/paycard/delete`,
                                        'POST',
                                        { cc_id: profile.paycards[cc_index].cc_id },
                                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                                    );
                                    if (res.status) {
                                        toast_message(true, res.msg, 2000);
                                        refresh_user_info();
                                    } else {
                                        toast_message(false, res.msg || 'Failed', 2000);
                                    }
                                }
                            });
                        }}>Delete</button>
                        {/if}
                    </td>
                </tr>
                {/each}
            </table>
        </div>
        {:else}
        <div class="sectioninfo">
            <div class="cardentryholder">
                <h6>Edit Card</h6>
                <CreditCardEntry
                    bind:cc_number={cc_number}
                    bind:cc_name={cc_name}
                    bind:cc_cvc={cc_cvc}
                    bind:cc_expiry={cc_expiry}
                    bind:is_cc_number_valid={is_cc_number_valid}
                    bind:is_cc_cvc_valid={is_cc_cvc_valid}
                    bind:is_cc_expiry_valid={is_cc_expiry_valid}
                    bind:is_new={new_card_false}
                />
                <button class="action" on:click={async () => {
                    // if (cc_number.includes('*') || cc_cvc.includes('*')) {
                    //     is_cc_number_valid = false;
                    //     is_cc_cvc_valid = false;
                    //     return;
                    // }
                    is_busy = true;
                    show_cc_entry = !show_cc_entry;
                    const res = await doFetch(
                        `${api_host}/api/paycard/update`,
                        'POST',
                        {
                            uid,
                            cc_id: profile.paycards[editing_cc_index].cc_id,
                            cc_name: cc_name,
                            cc_number: cc_number,
                            cc_expiry: cc_expiry,
                            cc_cvc: cc_cvc
                        },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        refresh_user_info();
                    } else {
                        toast_message(false, res.msg || 'Failed', 2000);
                    }
                    is_busy = false;
                }}>Save</button>
                <button class="cancel" on:click={() => { show_cc_entry = !show_cc_entry; }}>Cancel</button>
            </div>
            <br />
        </div>
        {/if}
        {#if !add_cc_entry}
            <div class="billininginfobuttonholder">
                <button class="action" on:click={() => { add_cc_entry = true; }}>Add Card</button>
            </div>
        {/if}
        {#if add_cc_entry}
            <div class="cardentryholder">
                <h6>Add Card</h6>
                <CreditCardEntry
                    bind:cc_number={new_cc_number}
                    bind:cc_name={new_cc_name}
                    bind:cc_cvc={new_cc_cvc}
                    bind:cc_expiry={new_cc_expiry}
                    bind:is_cc_number_valid={is_new_cc_number_valid}
                    bind:is_cc_cvc_valid={is_new_cc_cvc_valid}
                    bind:is_cc_expiry_valid={is_new_cc_expiry_valid}
                />
                <button class="action" on:click={async () => {
                    is_busy = true;
                    add_cc_entry = !add_cc_entry;
                    const res = await doFetch(
                        `${api_host}/api/paycard/add`,
                        'POST',
                        {
                            hid: uid,
                            cc_name: new_cc_name,
                            cc_number: new_cc_number,
                            cc_expiry: new_cc_expiry,
                            cc_cvc: new_cc_cvc
                        },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        refresh_user_info();
                    } else {
                        toast_message(false, res.msg || 'Failed', 2000);
                    }
                    is_busy = false;
                }}>Save</button>
                <button class="cancel" on:click={() => { add_cc_entry = !add_cc_entry; }}>Cancel</button>
            </div>
        {/if}
    </div>
    {/if}

    {#if isPasswordRequire(profile.role)}
    <div class="section changepassword">
        <div class="sectionsubtitle">Change Password</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff rowwrap pricingsettings">
                {#each fields.filter((e)=>e.group === "password") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    comparePassword={comparePassword}
                    bind:value={nf.value}
                    bind:disabled={is_password_keep}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
                <div class="group" style="margin-top: 40px;margin-left: 15px;">
                    <input type="checkbox" id="use_current_password" bind:checked={is_password_keep} on:input={(evt) => {
                        fields[12].validation_function(evt);
                        fields[13].validation_function(evt);
                    }} />
                    <label for="use_current_password">Don't change password</label>
                </div>
            </div>
        </div>
        {#if !is_password_keep}
            <div style="padding-left: 15px;color: #2f2f2f;">
                Password must contain:
                <ul>
                    <li>Minimum 6 characters</li>
                    <li>A lowercase letter</li>
                    <li>A capital letter</li>
                    <li>A number</li>
                </ul>
            </div>
        {/if}
    </div>
    {/if}

    {#if fields[3].value.toLowerCase() == 'contractor' || fields[3].value.toLowerCase() == 'employee'}
        <div class="section crewinformation">
            <div class="sectionsubtitle">Crew Information</div>
            {#if fields[3].value.toLowerCase() == 'contractor'}
                <div class="ff rowwrap pricingsettings">
                    {#each fields.filter((e)=>e.group === "contractor") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                        readonly={nf.readonly}
                        disabled={nf.disabled}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:value={nf.value}
                        bind:change_function={nf.change_function}
                        bind:validation_function={nf.validation_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                    {/each}
                </div>
            {/if}
            <div class="ff formrow pricingsettings">
                {#each fields.filter((e) => e.group === "contractor2") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:hidden={nf.hidden}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
        </div>
    {/if}

    <div class="section additionalinformation">
        <div class="sectionsubtitle">Additional Information</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff formrow pricingsettings">
                {#each fields.filter((e) => e.group === "comments") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    maxlength={nf.maxlength}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
        </div> 
    </div>

    <div class="section updatebutton">
        <button class="save" on:click={update_user} disabled={is_busy}>Update User</button>
        &nbsp;&nbsp;
        <button class="backbutton" on:click={() => { pop(); }}>
            <i class="fas fa-arrow-circle-left"></i> Back
        </button>
    </div>
</div>


<style>
    .ff {
        padding: 10px;
        padding-bottom: 0px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .formrow {
        padding: 0px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }
    .basic {
        grid-column: span 2;
    }
    .billininginfo {
        grid-column: span 2;
    }
    .changepassword {
        grid-column: span 2;
    }
    .crewinformation {
        grid-column: span 2;
    }
    .additionalinformation {
        grid-column: span 2;
    }
    .updatebutton {
        grid-column: span 2;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
    .updatebutton .save {
        background-color: #357a38;
        color: white;
    }
    .backbutton {
        background-color: #808080;
        color: white;
    }
    .updatebutton button {
        padding-left: 20px;
        padding-right: 20px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 320px;
        max-width: 320px;
    }

    :global(.rowwrap .group) {
        min-width: 320px;
        max-width: 320px;
    }
    :global(.settingsqlbutton .filterbuttonholder) {
        width: 600px !important;
    }
    .billininginfotableholder table th {
        border-bottom: 1px solid #ccc;
    }
    .billininginfotableholder table th,td {
        padding-left: 10px;
        padding-right: 10px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 0px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .sectioninfo {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        .contentholder {
            width: 100%;
            padding: 0px;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 20px;

        }
        .contactdetails {
            grid-column: span 2;
        }
        .map {
            grid-column: span 2;
        }
        .updatebutton {
            display: flex;
            flex-direction: column;
            padding: 0px;
        }
        .updatebutton .save {
            width: 100%;
            background-color: #357a38;
            color: white;
        }
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }

        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        :global(.settingsqlbutton .filterbuttonholder) {
            width: 100% !important;
        }
    }
    .cc_default {
        display: inline;
        background: lightgray;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
    .cc_edit_btn {
        cursor: pointer;
        display: inline;
        background: green;
        color: white;
        border-radius: 5px;
        padding: 2px 7px 2px 7px;
    }
    .cc_delete_button {
        background: red;
    }
    .cc_set_default_btn {
        cursor: pointer;
        display: inline;
        background: #1769aa;
        color: white;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
</style>